
import NavbarPro from './NavbarPro'

const Header = () => {
  return (
    <>
    <NavbarPro />
    </>
  )
}

export default Header